
export default {
    statusVaga: {},
    statusVagas: []
}